/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Agent_Policy_Ceiling_DescriptionInputs */



/**
* | output |
* | --- |
* | "The highest action limit any agent may be given. At most {max}." |
*
* @param {Agent_Policy_Ceiling_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_ceiling_description = /** @type {((inputs: Agent_Policy_Ceiling_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Ceiling_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Das höchste Aktionslimit, das ein Agent erhalten darf. Höchstens ${i?.max}.`)
	return /** @type {LocalizedString} */ (`The highest action limit any agent may be given. At most ${i?.max}.`)
});